import AxiosJob from '@/services/api/job/axios_job'

export default {
  createStatus: (data) => {
    return AxiosJob.post('status', data)
  },

  updateStatus: (statusId, data) => {
    return AxiosJob.put(`status/${statusId}`, data)
  },

  getAllStatuses: (params) => {
     return AxiosJob.get('status', { params })
  },

  getStatus: (statusId) => {
    return AxiosJob.get(`status/${statusId}`)
  },

  deleteStatus: (statusId) => {
    return AxiosJob.delete(`status/${statusId}`)
  }
}
